import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import i18n from "i18next";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";

class MetricEligImpr extends MetricBase {
    constructor() {
        super({
            field: "metric_elig_impr",
            defaultVisibility: false,
            unit: CurrencyUnit,
            chartName: i18n.t("metrics.tripadvisor.elig_impr.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.elig_impr.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.elig_impr.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricEligImpr;
